<div class="files-page">
  <div class="files-toolbar">
    <app-sort-dropdown
      dropdownId="filesSortDropdown"
      [options]="sortOptions"
      [selected]="selectedSort"
      (selectedChange)="onSort($event)">
    </app-sort-dropdown>

    <app-search-input
      [(searchText)]="searchText"
      placeholder="Пребарај по име или број на налог..."
      (search)="loadFiles()">
    </app-search-input>

    <button
      type="button"
      class="btn primary-btn app-btn-toolbar rounded-4 d-flex align-items-center justify-content-center gap-2"
      aria-label="Додади датотека"
      data-bs-toggle="modal"
      data-bs-target="#createFileModal">
      <fa-icon [icon]="faPlus"></fa-icon>
      <span class="d-none d-sm-inline">Додади</span>
    </button>
  </div>

  @if (loading) {
    <app-loading-spinner></app-loading-spinner>
  }

  @if (error) {
    <app-error-alert class="d-block mb-3" [message]="error"></app-error-alert>
  }

  @if (!loading && files.length > 0) {
    <div class="files-list-shell">
      <div
        class="table-responsive w-100 app-table-card order-files-table-wrapper files-table-wrapper"
        role="region"
        aria-label="Датотеки"
        tabindex="0">
        <table class="table table-hover mb-0 align-middle app-data-table order-files-table files-table">
          <thead>
            <tr>
              <th scope="col">
                <span class="d-md-none">Датотека</span>
                <span class="d-none d-md-inline">Име</span>
              </th>
              <th scope="col" class="file-preview-column" aria-label="Преглед"></th>
              <th scope="col" class="d-none d-lg-table-cell">Опис</th>
              <th scope="col" class="d-none d-md-table-cell">Големина</th>
              <th scope="col" class="d-none d-md-table-cell">Датум</th>
              <th scope="col" class="text-center order-file-action-column files-action-column">
                <span class="d-none d-md-inline">Преземи</span>
                <span class="visually-hidden d-md-none">Преземи</span>
              </th>
            </tr>
          </thead>
          <tbody>
            @for (file of files; track file.id ?? file.fileName ?? file.name) {
              <tr>
                <td class="text-start">
                  <span class="fw-semibold order-file-name">{{ getFileName(file) }}</span>
                  @if (file.description) {
                    <div class="d-lg-none small text-muted text-break mt-1">{{ file.description }}</div>
                  }
                  <div class="d-md-none small text-muted mt-1">
                    {{ formatBytes(file.sizeInBytes) }}
                    <span aria-hidden="true">&middot;</span>
                    @if (getFileDateValue(file)) {
                      {{ getFileDateValue(file) | appDate:'date':formatting.formats() }}
                    } @else {
                      <span>-</span>
                    }
                  </div>
                </td>
                <td class="text-center file-preview-column">
                  @if (isPreviewableImage(file)) { <app-file-image-preview [file]="file" [primaryButton]="true" /> }
                </td>
                <td class="d-none d-lg-table-cell text-break">
                  {{ file.description }}
                </td>
                <td class="d-none d-md-table-cell text-nowrap">{{ formatBytes(file.sizeInBytes) }}</td>
                <td class="d-none d-md-table-cell text-muted text-nowrap">
                  @if (getFileDateValue(file)) {
                    {{ getFileDateValue(file) | appDate:'date':formatting.formats() }}
                  } @else {
                    <span>-</span>
                  }
                </td>
                <td class="text-center order-file-action-column files-action-column">
                  <div class="d-flex align-items-center justify-content-center gap-2">
                    <button
                      type="button"
                      class="btn primary-outline-btn rounded-3 d-inline-flex align-items-center gap-2 order-file-action-button files-action-button"
                      [disabled]="isDownloading(file.id)"
                      [attr.aria-label]="'Преземи ја датотеката ' + getFileName(file)"
                      (click)="downloadFile(file)">
                      @if (isDownloading(file.id)) {
                        <span class="spinner-border spinner-border-sm" aria-hidden="true"></span>
                        <span class="d-none d-md-inline">Преземање</span>
                      } @else {
                        <fa-icon [icon]="faDownload"></fa-icon>
                        <span class="d-none d-md-inline">Преземи</span>
                      }
                    </button>
                  </div>
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>

      @if (filePage) {
        <mat-paginator
          class="files-paginator"
          [length]="filePage.totalCount"
          [pageIndex]="filePage.currentPage - 1"
          [pageSize]="filePage.pageSize"
          [pageSizeOptions]="[5, 10, 25, 50]"
          [showFirstLastButtons]="true"
          [hidePageSize]="true"
          (page)="onPageChange($event)">
        </mat-paginator>
      }
    </div>
  } @else if (!loading && !error) {
    <app-no-items-found text="Не се пронајдени датотеки."></app-no-items-found>
  }
</div>

<div class="modal fade" id="createFileModal" tabindex="-1" aria-hidden="true" #createFileModal>
  <div class="modal-dialog modal-lg modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-body p-4">
        <app-create-files
          [inModal]="true"
          (completed)="handleCreateCompleted()"
          (cancelled)="handleCreateCancelled()">
        </app-create-files>
      </div>
    </div>
  </div>
</div>
